export default __webpack_public_path__ + "src/assets/TEAM-Platform-Training-Manual.pdf";